import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls the window to the top (0, 0) whenever the route changes.
 * This component renders nothing and should be placed inside the Router component.
 * 
 * Usage:
 *   <Router>
 *     <ScrollToTop />
 *     <Routes>...</Routes>
 *   </Router>
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

